import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { useOpenCopilot } from 'copilot-toolkit/hooks/useOpenCopilot';
import { BulbIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { LowDisruptPrompt } from '../../components/LowDisruptPrompt';
import { tracker } from '../../tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTitle = app => {
  switch (app) {
    case 'sequences':
      return I18n.text('trial-components-library.copilotPrompt.sequences.title');
    default:
      return '';
  }
};
export const ContextualAITrialPrompt = ({
  app
}) => {
  const openCopilot = useOpenCopilot();
  return /*#__PURE__*/_jsxs(LowDisruptPrompt, {
    icon: /*#__PURE__*/_jsx(BulbIcon, {
      size: "800",
      color: "fill-accent-yellow-default"
    }),
    title: getTitle(app),
    id: "contextual-trial-prompt",
    secondaryColor: "fill-accent-yellow-subtle",
    primaryColor: "fill-accent-yellow-default",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "p",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trial-components-library.copilotPrompt.body"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: "400",
      marginInlineEnd: "300",
      flexDirection: "column",
      gap: "300",
      alignItems: "start",
      children: /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(AIButton, {
          size: "small",
          use: "tertiary",
          usageTracker: tracker,
          onClick: () => openCopilot(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "trial-components-library.copilotPrompt.askSomethingElse"
          })
        })
      })
    })]
  });
};